import { CanActivateFn } from '@angular/router';

export const browserCompatGuard: CanActivateFn = () => {
  const ua = navigator.userAgent;
  const msie = ua.indexOf("MSIE ");

  if (msie > 0 || !!ua.match(/Trident.*rv:11\./)) {
    window.location.href = "https://notificationwebhookprodl1svqs.azurewebsites.net/api/BrowserError";
    return false
  }
  return true;
};
